import React, { useState } from 'react';
import './css/OnlineExam.css';

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images here
import examHeroBg from '../images/banner-elibrary.jpg';
import featureSectionBg from '../images/Banner2.png';
// import tabSectionBg from '../images/Banner2.png'; // Background for the new interactive tab section
import showcaseImage from '../images/ElibraryRight.png'; // Preview image for the right side

import twinBg from "../images/Banner3.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle
import circle2Icon3 from "../images/CardImage1.png"; // Icon for the first circle
import circle2Icon4 from "../images/CardImage3.png"; // Icon for the second circle
import DownloadAppLMS from './components/DownloadAppLMS';

function Elibrary() {
    // State to track the active tab index (0 to 3)
    const [activeTab, setActiveTab] = useState(0);

    // State to control YouTube Video Popup Modal visibility
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    // Tab content data structure
    const tabData = [
        {
            title: "Concept Maps & Content (CMC)",
            description:
                "The CMC  section is a comprehensive knowledge repository that combines concept maps, detailed notes, AI-assisted search, and recorded faculty lectures to support effective learning. Each concept map provides a complete overview of a chapter, including keywords, concepts, formulae, and logical flow. Every highlighted section is hyperlinked to detailed explanations, allowing students to seamlessly move between a chapter overview and in-depth content. Student engagement with the CMC is also tracked and reflected in the Performance Scorecard (PSC), helping learners monitor their academic progress."
        },
        {
            title: "Demo",
            description:
                "Crestest offers Demo access for both Guest Users and Registered Users, allowing everyone to explore the CMC portal and experience its intuitive interface and learning resources. Guest users can browse the concept maps and content, while registered users gain access to additional hyperlinked information by creating a free account. Paid subscribers further benefit from the AI-assisted search facility, enabling instant access to relevant concepts and answers in real time."
        },
        {
            title: "Spectrum",
            description:
                "The CMC is divided into two categories—Scholastic and Competitive. In the Scholastic section, students can choose the complete course or subscribe only to the individual subjects they require. For Competitive preparation, students enroll in complete examination modules tailored to their target exams. Additionally, students who subscribe to the NBF facility receive access to recorded video lectures, providing a comprehensive multimedia learning experience."
        },
        {
            title: "Your Choice",
            description:
                "Crestest provides complete flexibility by allowing students to subscribe only to the resources they need. Scholastic learners can select individual subjects, while Competitive learners can choose the examination modules relevant to their goals. There is no requirement to subscribe to the entire offering. As students become familiar with the platform and build confidence in the learning process, they can expand their subscriptions at any time according to their academic needs."
        }
    ];

    return (
        <div className="online-exam-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="online-exam-hero-section"
                style={{ backgroundImage: `url(${examHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 3. New Interactive Tab & Video Showcase Section */}
            <section
                className="online-exam-interactive-section"
            // style={{ backgroundImage: `url(${tabSectionBg})` }}
            >
                <div className="container-fluid p-0">
                    <div className="row g-0 align-items-center">

                        {/* Left Part: 4 Tabs in a row with dynamic sub-description */}
                        <div className="col-lg-6 px-lg-5 py-5">
                            <div className="interactive-left-content">
                                <span className="interactive-mini-tag" style={{ color: '#083c66' }}>
                                    CONCEPT MAPS & CONTENT
                                </span>

                                <h2 className="interactive-heading" style={{ color: '#FBBB1B' }}>
                                    Explore Knowledge Through Smart Learning
                                </h2>

                                <div
                                    className="zigzag-border mt-2 mb-4"
                                    style={{ backgroundColor: '#083c66' }}
                                ></div>

                                {/* 4 Tabs Row */}
                                <div className="exam-tabs-header-row">
                                    {tabData.map((tab, index) => (
                                        <button
                                            key={index}
                                            className={`exam-tab-btn ${activeTab === index ? 'active' : ''}`}
                                            onClick={() => setActiveTab(index)}
                                        >
                                            {tab.title}
                                        </button>
                                    ))}
                                </div>

                                {/* Dynamic Sub-description Container */}
                                <div className="exam-tab-content-box">
                                    <h4 className="tab-dynamic-title">{tabData[activeTab].title} Workflow</h4>
                                    <p className="tab-dynamic-desc">{tabData[activeTab].description}</p>
                                </div>
                            </div>
                        </div>

                        {/* Right Part: Reduced image sizing cleanly centered with play button */}
                        <div className="col-lg-6 position-relative video-showcase-col">
                            <div className="video-bg-wrapper">
                                <img src={showcaseImage} alt="Platform Showcase Preview" className="showcase-img" />

                                {/* Center-aligned custom play button */}
                                <button
                                    className="custom-center-play-btn"
                                    onClick={() => setIsVideoModalOpen(true)}
                                    aria-label="Play video showcase"
                                >
                                    <span className="play-icon-triangle"></span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Customized Premium Bordered Popup Modal for YouTube Video */}
            {isVideoModalOpen && (
                <div className="premium-video-modal-backdrop" onClick={() => setIsVideoModalOpen(false)}>
                    <div className="premium-video-modal-container" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="premium-modal-close-btn"
                            onClick={() => setIsVideoModalOpen(false)}
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <div className="premium-video-frame-wrapper">
                            <iframe
                                className="youtube-iframe-embed"
                                src="https://www.youtube.com/embed/udIt59i5_k0?autoplay=1"
                                title="Platform Showcase Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}

            {/* 2. Content Section matching style theme */}
            <section
                className="online-exam-content-section"
                style={{ backgroundImage: `url(${featureSectionBg})` }}
            >
                <div className="container py-5">
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span
                                className="grid-section-mini-tag"
                                style={{ color: "#083c66" }}
                            >
                                CMC HIGHLIGHTS
                            </span>

                            <h2
                                className="grid-section-heading"
                                style={{ color: "#FBBB1B" }}
                            >
                                Everything You Need to Master Every Concept
                            </h2>

                            <div
                                className="zigzag-border mx-auto mt-2"
                                style={{ backgroundColor: "#083c66" }}
                            ></div>
                        </div>
                    </div>

                    <div className="row g-4 justify-content-center">

                        {/* Card 1 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-box-text-block">
                                        <h4>Concept Maps & Notes</h4>
                                        <p>
                                            Understand every chapter through structured concept maps,
                                            concise notes, keywords, formulae, and interconnected
                                            explanations that simplify even the most complex topics.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-box-text-block">
                                        <h4>AI-Powered Search</h4>
                                        <p>
                                            Instantly find concepts, explanations, and related topics
                                            using our intelligent AI-assisted search facility, helping
                                            students learn faster and more efficiently.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Card 3 */}
                        {/* Card 3 */}
                        <div className="col-lg-4 col-md-6">
                            <div className="glass-grid-box">
                                <div className="grid-box-inner">
                                    <div className="grid-box-text-block">
                                        <h4>Interactive Learning</h4>
                                        <p>
                                            Explore hyperlinked concept maps that let you seamlessly navigate
                                            from chapter overviews to detailed explanations, making learning
                                            more interactive, engaging, and easy to understand.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadAppLMS />

            {/* 4. NEW: Overlapping Dual Card Section */}
            <section
                className="twin-cards-section"
                style={{ backgroundImage: `url(${twinBg})` }}
            >
                <div className="container">

                    {/* Section Header (Center Aligned) */}
                    <div className="row justify-content-center text-center twin-header-margin">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text" style={{ color: '#0f507a' }}>
                                SMART KNOWLEDGE CENTER
                            </p>

                            <h2 className="cards-main-heading" style={{ color: '#FBBB1B' }}>
                                Discover, Understand & Retain Every Concept
                            </h2>

                            <div
                                className="zigzag-border"
                                style={{ backgroundColor: '#0f507a' }}
                            ></div>
                        </div>

                    </div>

                    {/* Dual Cards Row */}
                    <div className="row g-5 justify-content-center twin-row-padding">

                        {/* Left Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent1">
                                    <img src={circle2Icon1} alt="E-Library" className="floating-circle-icon" />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon3}
                                        alt="Online Exams Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#207AB4",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        Online Exams
                                    </h4>

                                    <p className="overlap-sub-text">
                                        Students are encouraged to begin their learning journey by taking online
                                        tests to assess their current academic knowledge. Based on their
                                        performance, they can choose the most suitable learning pathway,
                                        promoting a self-aware, learner-centric approach that fosters
                                        responsibility, continuous improvement, and meaningful learning beyond
                                        rote memorization.
                                    </p>

                                    <a
                                        href="/online-exams"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: "#207AB4" }}
                                    >
                                        EXPLORE ONLINE EXAMS
                                    </a>
                                </div>

                            </div>
                        </div>

                        {/* Right Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent2">
                                    <img
                                        src={circle2Icon2}
                                        alt="Performance Scorecard"
                                        className="floating-circle-icon"
                                    />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon4}
                                        alt="Performance Scorecard Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#57BDB9",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        Performance Scorecard
                                    </h4>

                                    <p className="overlap-sub-text">
                                        Our Performance Scorecard provides a comprehensive view of a
                                        student's progress through detailed statistics and interactive
                                        graphs. It identifies strengths, highlights areas that need
                                        improvement, and enables learners to compare scholastic and
                                        competitive performance through a dynamic, data-driven interface.
                                    </p>

                                    <a
                                        href="/performance-scorecard"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: '#57BDB9' }}
                                    >
                                        VIEW SCORECARD
                                    </a>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>





            {/* Bottom Global Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Elibrary;

